import React from "react";
import "./RequestAQuote.css";

const RequestAQuote = () => {
  return (
    <div>
      <h1>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eum,
        dignissimos?
      </h1>
    </div>
  );
};

export default RequestAQuote;
